import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export function initImageTextSlider() {
    const imageTextSliders = document.querySelectorAll(".pul-text-image-slider .swiper");

    if(imageTextSliders.length > 0) {
        for (const slider of imageTextSliders) {
            const prevEl = slider.previousElementSibling.querySelector(".swiper-button-prev");
            const nextEl = slider.previousElementSibling.querySelector(".swiper-button-next");
            new Swiper(slider, {
                modules: [Navigation, Pagination],
                loop: true,
                spaceBetween: 30,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl
                }
            })
        }
    }
}